import {Injectable} from "@angular/core";
import {routesNames} from "@app/app-routing.module";
import {DeleteListComponent} from "@app/presentation/pages/delete-list/delete-list.component";
import {CreateListComponent} from "@app/presentation/pages/create-list/create-list.component";
import {AddToListComponent} from "@app/presentation/pages/add-to-list/add-to-list.component";
import {Observable} from "rxjs";
import {List} from "@app/core/lists/domain/list";
import {Product} from "@app/core/product/domain/dtos/product";
import {RETURN_URL_QUERY_PARAM_KEY} from "@app/presentation/utils/return-url-query-param-key";
import {DesktopModalType, MobileModalType, ModalService} from "@app/presentation/services/modal/modal.service";

/**
 * Service for managing actions in lists that require showing modals.
 */
@Injectable({
    providedIn: 'root'
})
export class ListActionModalService {

    routesNames = routesNames;

    constructor(
        private modalService: ModalService,
    ) {
    }

    openAddToList(product: Product, returnUrl?: string | null): Observable<List | undefined> {
        const data = {
            product,
            queryParams: {
                ...(returnUrl ? {[RETURN_URL_QUERY_PARAM_KEY]: returnUrl} : {})
            }
        }
        return this.modalService.open(AddToListComponent, {
            data: data,
            mobileModalType: MobileModalType.BOTTOM_SHEET,
            desktopModalType: DesktopModalType.SIDE_SHEET,
        });
    }

    openRenameList(listId: number) {
        const data = {
            listId: listId,
        }
        this.modalService.open(CreateListComponent, {
            data: data,
            mobileModalType: MobileModalType.BOTTOM_SHEET,
            desktopModalType: DesktopModalType.SIDE_SHEET,
        });
    }

    openDeleteList(listId: number) {
        const data = {
            listId: listId,
        }
        this.modalService.open(DeleteListComponent, {
            data: data,
            mobileModalType: MobileModalType.BOTTOM_SHEET,
            desktopModalType: DesktopModalType.SIDE_SHEET,
        });
    }

    openCreateList(productsCodes: string[], returnUrl?: string | null) {
        const data = {
            productsCodes: productsCodes,
            queryParams: {
                ...(returnUrl ? {[RETURN_URL_QUERY_PARAM_KEY]: returnUrl} : {})
            }
        };
        this.modalService.open(CreateListComponent, {
            data: data,
            desktopModalType: DesktopModalType.SIDE_SHEET,
            mobileModalType: MobileModalType.BOTTOM_SHEET,
        });
    }

}
